<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/academics/semester-create"><i class="fas fa-plus"></i> {{ "ADD" | translate |
                titlecase }}</button>
        </div>
        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "SEMESTERS" | translate | titlecase }}</h5>
                <app-loader [show]="showLoader"></app-loader>
                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <table *ngIf="semesters.length >= 1" class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th>{{ "ID" | translate | titlecase }}</th>
                                <th>{{ "YEAR_ID" | translate | titlecase }}</th>
                                <th>{{ "ARABIC_NAME" | translate | titlecase }}</th>
                                <th>{{ "ENGLISH_NAME" | translate | titlecase }}</th>
                                <th>{{ "START_DATE" | translate | titlecase }}</th>
                                <th>{{ "END_DATE" | translate | titlecase }}</th>
                                <th>{{ "DAYS" | translate | titlecase }}</th>
                                <th>{{ "ORDER" | translate | titlecase }}</th>
                                <th>{{ "ACTIVE" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "MODIFY" | translate | titlecase
                                    }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "PROGRESSION" | translate | titlecase
                                    }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "UNDO_PROGRESSION" | translate | titlecase
                                        }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of semesters">
                                <td>{{res?.id}}</td>
                                <td>{{res?.yearid}}</td>
                                <td>{{res?.semesterNameAr}}</td>
                                <td>{{res?.semesterNameEn}}</td>
                                <td>{{res?.startDate | date}}</td>
                                <td>{{res?.endDate | date}}</td>
                                <td>{{res?.daysNo }}</td>
                                <td>{{res?.orderNo }}</td>
                                <td>{{res?.activeFlag }}</td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-warning" routerLink="/academics/semester-update"
                                        [queryParams]="{semesterId: res?.id}"><i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</a>
                                </td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-warning" (click)="onProgression(res?.id,res?.yearid)" data-toggle="modal"
                                        data-target="#progressionInfoModal"><i class="fas fa-edit"></i>
                                        {{ "PROGRESSION" | translate | titlecase }}</a>
                                    <!-- <i class="fas fa-edit"></i> -->
    
                                </td>  
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-warning" (click)="onProgressionUndo(res?.id,res?.yearid)"
                                    data-toggle="modal"
                                    data-target="#progressionUndoInfoModal"><i class="fas fa-edit"></i>
                                    {{ "UNDO_PROGRESSION" | translate | titlecase }}</a>
                                <!-- <i class="fas fa-edit"></i> -->
                                </td>                                                                
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="progressionUndoInfoModal" tabindex="-1" aria-labelledby="progressionUndoInfoModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <!-- <i class="fas fa-trash text-danger"></i> -->
                    <i class="fas fa-info-circle"></i>
                </div>
                <!-- <div class="p-2"><b>{{ "NOT_AVAILABLE" | translate | titlecase }}</b> </div> -->
                <div class="p-2"><b>{{ progressionUndoMsg }}</b> </div>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="progressionInfoModal" tabindex="-1" aria-labelledby="progressionInfoModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <!-- <i class="fas fa-trash text-danger"></i> -->
                    <i class="fas fa-info-circle"></i>
                </div>
                <!-- <div class="p-2"><b>{{ "NOT_AVAILABLE" | translate | titlecase }}</b> </div> -->
                <div class="p-2"><b>{{ progressionMsg }}</b> </div>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>
